import React from "react";
import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import slider1 from "../assets/img/carousel/slider1.png";
import slider2 from "../assets/img/carousel/slider2.png";
import "./Header.css";

function Header() {
  return (
    <Carousel
      className="w-100 animate__animated animate__fadeIn mt-responsive"
      fade
      controls={true}
    >
      <Carousel.Item>
        <div className="position-relative">
          <div className="animate__animated animate__fadeInUp position-absolute header-content herbal-tisane">
            <h2 className="caption-title text-white text-shadow">
              HERBAL TISANE
            </h2>
            <p className="caption-text text-white text-shadow pt-2 pt-sm-0 pb-3">
              for calming winter nights
            </p>
            <Link
              to={"/category/herbaltea"}
              className="btn btn-yellow d-flex align-items-center justify-content-center header-btn shadow"
            >
              SHOP NOW
            </Link>
          </div>
          <div className="position-absolute header-transparency"></div>
          <img
            className="carousel-img d-block w-100 img-fluid"
            src={slider2}
            alt="Second slide"
          />
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <div className="position-relative">
          <div className="animate__animated animate__fadeInUp position-absolute header-content">
            <h2 className="caption-title text-white text-shadow">
              GREEN REMEDIES
            </h2>
            <p className="caption-text text-white text-shadow pt-2 pt-sm-0  pb-3 px-sm-2">
              A collection of teas celebrating imperial roots and history
            </p>
            <Link
              to={"/category/greentea"}
              className="btn btn-yellow d-flex align-items-center justify-content-center header-btn shadow"
            >
              SHOP NOW
            </Link>
          </div>
          <div className="position-absolute header-transparency"></div>
          <img
            className="carousel-img d-block w-100 img-fluid"
            src={slider1}
            alt="First slide"
          />
        </div>
      </Carousel.Item>
    </Carousel>
  );
}

export default Header;
